import { Component, Inject, Input, OnInit, ViewChild } from '@angular/core';
import { SaveService } from '../../../services/save.service';
import { DefaultValuesService } from '../../../services/defaultvalues.service';
import { DialogService } from '../../../services/dialog.service';
import { MatChipInputEvent } from '@angular/material/chips';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { Utils } from '../../../utils/utils';
import { HttpClient } from '@angular/common/http';
import { ChangeHistoryDialogue } from "../dialog-change-history/dialog-change-history";
import { MatDialog } from "@angular/material/dialog";
import { filter } from 'rxjs';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'contact-list',
  templateUrl: './contact-list.component.html',
    styleUrls: ['./contact-list.component.less', '../../../style/mat-table.component.less'],
    standalone: false,
    animations: [
        trigger('detailExpand', [
            state('collapsed', style({ height: '0px', minHeight: '0', display: 'none' })),
            state('expanded', style({ height: '*' })),
            transition('expanded => collapsed', [animate('0ms cubic-bezier(0.4, 0.0, 0.2, 1)')]),
        ]),
    ]
})
export class ContactListComponent implements OnInit {
    @Input('list') list: ContactInfoHub[] = [];
    @Input('showLocalFilter') showLocalFilter = false;
    @ViewChild(MatTable, { static: true }) table!: MatTable<any>;
    @Input('chipSeparatorKeyCodes') separatorKeysCodes: number[] = [];
    columnsToDisplay = ['arrow', 'index', 'ContactId', 'ContactType', 'ContactName', 'ContactFirstName', 'ContactLastName', 'ContactEMail', '_ChangedAtUtc', 'actions'];
    subcolumnsToDisplay = ['ContactPhone', 'ContactPosition', 'IsDeleted', 'ContactSince'];
    dateColumns = ['_ChangedAtUtc', 'ContactSince'];
    notEditableColumns = ['ContactId', '_ChangedAtUtc'];
    booleanColumns = ['IsDeleted'];

    searchItems: string[] = [];
    public dataSource = new MatTableDataSource<ContactInfoHub>();
    subscriptionTenant: any;
    clonedList: { [s: string]: ContactInfoHub; } = {};
    expandedElements = new Set();
    removable = true;
    addOnBlur = true;
    selectable= true;

    constructor(
        private saveService: SaveService
        , private defaults: DefaultValuesService
        , private confimDialog: DialogService
        , private http: HttpClient
        ,@Inject('BASE_URL') private baseUrl: string
        , private dialog: MatDialog
        , private toastrService: ToastrService
    ) { }
        

    ngOnInit(): void {
        this.getHeader();
        this.subscriptionTenant = this.defaults.tenantMessageChanges$.subscribe(() => {
            this.getHeader()
        });
        this.dataSource.filterPredicate = (data: ContactInfoHub, filters: string) => {
            const matchFilter: boolean[] = [];
            const filterArray = filters.split('+').filter(x => x.indexOf('notextfilters') < 0)
            if (filterArray.length > 0) {
                filterArray.forEach((filter) => {
                    const fields: string[] = []
                    fields.push(data.ContactId ? data.ContactId : '')
                    fields.push(data.ContactType ? data.ContactType : '')
                    fields.push(data.ContactName ? data.ContactName : '')
                    fields.push(data.ContactFirstName ? data.ContactFirstName : '')
                    fields.push(data.ContactLastName ? data.ContactLastName : '')
                    fields.push(data.ContactEmail ? data.ContactEmail : '')
                    return matchFilter.push(fields.some(item => item.includes(filter)));
                });
            }
            else {
                const result = true;
                matchFilter.push(result);
            }
            return matchFilter.some(Boolean);
        };
    }

    ngOnChanges() {
        this.dataSource.data = this.list;
        this.clonedList = {};
        this.saveService.showSaveButton(false);
        this.expandedElements.clear();
    }

    getHeader() {
        if (!this.defaults.isReadonlyUser) {
            this.columnsToDisplay = ['arrow', 'index', 'ContactId', 'ContactType', 'ContactName', 'ContactFirstName', 'ContactLastName', 'ContactEMail', '_ChangedAtUtc', 'actions'];
        }
        else {
            this.columnsToDisplay = ['arrow', 'index', 'ContactId', 'ContactType', 'ContactName', 'ContactFirstName', 'ContactLastName', 'ContactEMail', '_ChangedAtUtc'];
        }
    }

    getInput(data: ContactInfoHub, property: string): any {
        return data[property];
    }

    getDataType(property: string) {
        let result = ''
        if (this.booleanColumns.indexOf(property) > -1) {
            result = 'boolean';
        }
        else if (this.dateColumns.indexOf(property) > -1) {
            result = 'date';
        }
        else {
            result = 'string';
        }
        return result;
    }

    changeElement(object: any, type: string, value: boolean) {
        object[type] = value;
        this.table.renderRows();
    }

    applyFilter(event: MatChipInputEvent): void {
        const input = event.input;
        const value = event.value;
        if ((value || '').trim()) {
            this.searchItems.push(value.replace('+', '').trim());
        }
        // Reset the input value
        if (input) {
            input.value = '';
        }
        this.updatefilter()
    }

    isEditingRow(contact: ContactInfoHub, property: string) {
        return this.clonedList[contact.ContactId] &&
            (this.notEditableColumns.indexOf(property) < 0)
    }

    onRowEditInit(contact: ContactInfoHub) {
        this.saveService.addListener(this);
        this.clonedList[contact.ContactId] = { ...contact };
        if (Object.keys(this.clonedList).length > 0) {
            this.showSavebutton(true);
        }
        // Fetch and show expanded elements on row edit
        this.pushPopElement(contact);
    }

    onRowEditCancel(contact: ContactInfoHub) {
        this.dataSource.data[this.dataSource.data.findIndex(x => x.ContactId === contact.ContactId)] = this.clonedList[contact.ContactId];
        delete this.clonedList[contact.ContactId];
        if (Object.keys(this.clonedList).length === 0) {
            this.showSavebutton(false);
        }
        this.table.renderRows();
    }

    remove(item: string): void {
        const index = this.searchItems.indexOf(item);
        if (index >= 0) {
            this.searchItems.splice(index, 1);
        }
        this.updatefilter();
    }

    updatefilter() {
        let filterString: string
        if (this.searchItems.length === 0) {
            this.dataSource.filter = 'notextfilters'
        }
        else {
            filterString = this.searchItems.join('+') + '+checkboxes'
            this.dataSource.filter = filterString
        }
    }

    showSavebutton(val: boolean) {
        this.saveService.showSaveButton(val);
    }

    pushPopElement(element: ContactInfoHub) {
        if (this.expandedElements.has(element)) {
            this.expandedElements.delete(element);
        }
        else {
            this.expandedElements.add(element);
        }
    }

    checkExpanded(element: ContactInfoHub) {
        return this.expandedElements.has(element);
    }

    onSave() {
        const updatedList: any[] = [];
        for (let i in this.clonedList) {
            const index = this.dataSource.data.findIndex(x => x.ContactId === this.clonedList[i].ContactId);
            const obj = this.dataSource.data[index];
            let item = this.dataSource.data[index];
            updatedList.push(Utils.RemoveBlankFields(item));
        }
        if (updatedList.length > 0) {
            Utils.httpUpdateContacts(
                this.http,
                this.baseUrl,
                updatedList,
                this,
                function (tthis: ContactListComponent) {
                    tthis.toastrService.success('Contact(s) saved successfully');
                    tthis.clonedList = {}
                    tthis.saveService.showSaveButton(false)
                    tthis.expandedElements.clear();
                    tthis.table.renderRows();
                }, function (tthis: ContactListComponent) {
                    tthis.saveService.addListener(tthis)
                    tthis.saveService.showSaveButton(true)
                    tthis.confimDialog.showErrorDialog({ error: { message: "Error saving contacts" } });
                }
            )
        }
    }

    getDateUTCChange(event, data: ContactInfoHub, property: string) {
        let utcDate = Utils.dateUTCchange(event);
        data[property] = utcDate;
    }
    openChangeHistoryDialog(element: any) {
            const filteredElement = element ? Object.fromEntries(
            Object.entries(element).filter(([key]) => this.columnsToDisplay.includes(key))
        ) : undefined;
        if (filteredElement && element.TenantId) {
            filteredElement["TenantId"] = element.TenantId;
        }
        this.dialog.open(ChangeHistoryDialogue, {
            height: '535px',
            width: '900px',
            data: {
                entity: 'Contacts',
                row: filteredElement,
            }
        });
        }
}
